import inputDisabled from '../../../../common/algorithms/input-disabled';

const dark = (params) => inputDisabled(params);

export default dark;
